import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

const KPIManagement = () => {
  const [showDivisionModal, setShowDivisionModal] = useState(false);
  const [showDepartmentModal, setShowDepartmentModal] = useState(false);
  const [showSelfModal, setShowSelfModal] = useState(false);
  const [userRole, setUserRole] = useState("self");

  useEffect(() => {
    const jobLevel = localStorage.getItem("JobLevel");
    if (["03", "04", "04A", "04B"].includes(jobLevel)) {
      setUserRole("Department");
    } else if (["02A", "02"].includes(jobLevel)) {
      setUserRole("Division");
    } else if (["01A", "01"].includes(jobLevel)) {
      setUserRole("MD / Chairman");
    } else {
      setUserRole("self");
    }
  }, []);

  return (
    <div className="p-4">
      <div className="flex space-x-4 mb-4">
        <button
          className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700"
          onClick={() => setShowSelfModal(true)}
        >
          Self KPI
        </button>

        {(userRole === "Division" || userRole === "MD / Chairman") && (
          <button
            className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
            onClick={() => setShowDivisionModal(true)}
          >
            Division KPI
          </button>
        )}

        {(userRole === "Department" ||
          userRole === "Division" ||
          userRole === "MD / Chairman") && (
            <button
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              onClick={() => setShowDepartmentModal(true)}
            >
              Department KPI
            </button>
          )}
      </div>

      <KPIModal
        isOpen={showSelfModal}
        onClose={() => setShowSelfModal(false)}
        type="Self"
        kpiCriteria="S"
        isSelfKPI={true}
      />

      <KPIModal
        isOpen={showDivisionModal}
        onClose={() => setShowDivisionModal(false)}
        type="Division"
        kpiCriteria="D"
      />

      <KPIModal
        isOpen={showDepartmentModal}
        onClose={() => setShowDepartmentModal(false)}
        type="Department"
        kpiCriteria="E"
      />
    </div>
  );
};

const KPIModal = ({
  isOpen,
  onClose,
  type,
  kpiCriteria,
  isSelfKPI = false,
}) => {
  const [tableData, setTableData] = useState([
    { goalTitle: "", targetDate: "" },
  ]);
  const [serviceNo, setServiceNo] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [kpiCodes, setKpiCodes] = useState([]);
  const [justSaved, setJustSaved] = useState(false);
  const [deletedRows, setDeletedRows] = useState([]);

  const handleClose = () => {
    onClose();
    window.location.reload();
  };


  useEffect(() => {
    const storedServiceNo = isSelfKPI
      ? localStorage.getItem("serviceNo") || localStorage.getItem("username")
      : localStorage.getItem("serviceNo");
    if (storedServiceNo) setServiceNo(storedServiceNo);
  }, [isSelfKPI]);

  useEffect(() => {
    if (!isOpen) {
      setTableData([{ goalTitle: "", targetDate: "" }]);
      setKpiCodes([]);
      setJustSaved(false);
    } else if (isOpen && !justSaved) {
      fetchKPIData();
    }
  }, [isOpen]);

  const fetchKPIData = async () => {
    setIsLoading(true);
    try {
      const requestToken = localStorage.getItem("request_token");
      const year = localStorage.getItem("year");
      const userType = localStorage.getItem("userType") || "EX";

      const params = isSelfKPI
        ? {
          KPI_ServiceNo: serviceNo,
          UserType: userType,
        }
        : {
          KPI_Divition: localStorage.getItem("DiviCode"),
          KPI_Department: localStorage.getItem("DepCode"),
          UserType: userType,
        };

      const response = await axios.get(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/KpiFormLoad?year=${year}`,
        { params, headers: { request_token: requestToken } }
      );

      if (response.data?.ResultSet || response.data) {
        const dataArray = response.data.ResultSet || response.data;
        const filteredData = Array.isArray(dataArray)
          ? dataArray.filter((item) => item.KPI_Criteria === kpiCriteria)
          : [];

        if (filteredData.length > 0) {
          const formattedData = filteredData.map((item) => ({
            goalTitle: item.KPI_GTitle || "",
            targetDate: item.KPI_TDate || "",
          }));
          setKpiCodes(filteredData.map((item) => item.KPI_Code || ""));
          setTableData(formattedData);
        } else {
          setTableData([{ goalTitle: "", targetDate: "" }]);
          setKpiCodes([]);
        }
      }
    } catch (error) {
      Swal.fire("Error", `Failed to load ${type} KPI details`, "error");
      setTableData([{ goalTitle: "", targetDate: "" }]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddRow = () => {
    setTableData([...tableData, { goalTitle: "", targetDate: "" }]);
    setKpiCodes([...kpiCodes, ""]);
  };

  const handleInputChange = (index, field, value) => {
    const newData = [...tableData];
    newData[index][field] = value;
    setTableData(newData);
  };

  const handleDeleteRow = (index) => {

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this KPI entry?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {

        if (kpiCodes[index]) {
          try {
            const requestToken = localStorage.getItem("request_token");
            const year = localStorage.getItem("year");
            const userType = localStorage.getItem("userType") || "EX";


            const deletionPayload = {
              KPI_Criteria: kpiCriteria,
              KPI_Divition: localStorage.getItem("DiviCode") || '',
              KPI_Department: localStorage.getItem("DepCode") || '',
              KPI_ServiceNo: serviceNo || '',
              KPI_GTitle: tableData[index].goalTitle || '',
              KPI_TDate: tableData[index].targetDate || '',
              KPI_Status: "I",
              KPI_Code: kpiCodes[index],
              KPI_Year: localStorage.getItem("year") || ''
            };


            await axios.post(
              `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/SaveKPICriteriaDetails?UserType=${userType}&year=${year}`,
              [deletionPayload],
              {
                headers: {
                  request_token: requestToken,
                  "Content-Type": "application/json"
                }
              }
            );
          } catch (error) {
            console.error("Error deleting KPI entry:", error);
            Swal.fire("Error", "Failed to delete KPI entry", "error");
            return;
          }
        }


        const newData = tableData.filter((_, i) => i !== index);
        const newCodes = kpiCodes.filter((_, i) => i !== index);

        setTableData(newData);
        setKpiCodes(newCodes);


        Swal.fire(
          'Deleted!',
          'Your KPI entry has been deleted.',
          'success'
        );
      }
    });
  };


  const formatDataForAPI = () => {
    const KPI_Divition = localStorage.getItem("DiviCode");
    const KPI_Department = localStorage.getItem("DepCode");


    const activeRowsPayload = tableData.filter(row =>
      row.goalTitle && row.targetDate
    ).map((row, index) => {
      const payload = {
        KPI_Criteria: kpiCriteria,
        KPI_Divition: KPI_Divition || '',
        KPI_Department: KPI_Department || '',
        KPI_ServiceNo: serviceNo || '',
        KPI_GTitle: row.goalTitle || '',
        KPI_TDate: row.targetDate || '',
        KPI_Status: "A",
        KPI_Year: localStorage.getItem("year") || ''
      };


      if (kpiCodes[index]) {
        payload.KPI_Code = kpiCodes[index];
      }

      return payload;
    });


    const deletedRowsPayload = deletedRows.map(row => ({
      KPI_Criteria: kpiCriteria,
      KPI_Divition: KPI_Divition || '',
      KPI_Department: KPI_Department || '',
      KPI_ServiceNo: serviceNo || '',
      KPI_GTitle: row.goalTitle || '',
      KPI_TDate: row.targetDate || '',
      KPI_Status: "I",
      KPI_Code: row.KPI_Code || '',
      KPI_Year: localStorage.getItem("year") || ''
    }));

    return [...activeRowsPayload, ...deletedRowsPayload];
  };

  const saveToAPI = async () => {
    try {
      const requestToken = localStorage.getItem("request_token") || "";
      const formattedData = formatDataForAPI();


      if (formattedData.length === 0) {
        Swal.fire("Error", "No KPI data to save", "error");
        return false;
      }

      const year = localStorage.getItem("year");
      const userType = localStorage.getItem("userType") || "EX";


      const isValid = formattedData.every(item =>
        item.KPI_GTitle &&
        item.KPI_TDate
      );

      if (!isValid) {
        Swal.fire("Error", "Please fill in all required fields", "error");
        return false;
      }

      setIsLoading(true);

      const response = await axios.post(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/SaveKPICriteriaDetails?UserType=${userType}&year=${year}`,
        formattedData,
        {
          headers: {
            request_token: requestToken,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data && response.status === 200) {
        setJustSaved(true);

        Swal.fire({
          title: "Saved!",
          text: `Your ${type} KPI details have been saved successfully.`,
          icon: "success",
          showConfirmButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            fetchKPIData();
            setJustSaved(false);
          }
        });

        return true;
      } else {
        throw new Error("Failed to save data");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      Swal.fire("Error", `Failed to save KPI details: ${error.message}`, "error");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const buttonColor = isSelfKPI
    ? "bg-purple-600 hover:bg-purple-700"
    : type === "Division"
      ? "bg-indigo-600 hover:bg-indigo-700"
      : "bg-green-600 hover:bg-green-700";

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 max-w-4xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">{type} KPI Details</h2>
          <div>
            <span className="text-gray-600 mr-4">
              {isSelfKPI
                ? `Service No: ${serviceNo}`
                : type === "Division"
                  ? `Division Code: ${localStorage.getItem("DiviCode")}`
                  : `Department Code: ${localStorage.getItem("DepCode")}`}
            </span>
            <button
              className={`${buttonColor} text-white px-3 py-2 rounded mr-2`}
              onClick={handleAddRow}
            >
              Add Row
            </button>
          </div>
        </div>

        {isLoading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-700"></div>
          </div>
        ) : (
          <table className="w-full border-collapse text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Goal Title
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left">
                  Target Date
                </th>

                {!isSelfKPI && (
                  <th className="border border-gray-300 px-4 py-2 text-center">
                    Actions
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  <td className="border border-gray-300 px-4 py-2">
                    <input
                      type="text"
                      className="w-full px-2 py-1 border rounded"
                      value={row.goalTitle}
                      onChange={(e) =>
                        handleInputChange(index, "goalTitle", e.target.value)
                      }
                      placeholder={`Enter ${type} Goal Title`}
                    />
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <input
                      type="date"
                      className="w-full px-2 py-1 border rounded"
                      value={row.targetDate}
                      onChange={(e) =>
                        handleInputChange(index, "targetDate", e.target.value)
                      }
                    />
                  </td>

                  {!isSelfKPI && (
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <button
                        className="bg-red-500 text-white py-1 px-3 rounded hover:bg-red-600"
                        onClick={() => handleDeleteRow(index)}
                        disabled={tableData.length === 1 && index === 0 && !kpiCodes[index]}
                      >
                        Delete
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}

        <div className="flex mt-6 justify-end space-x-2">
          <button
            className={`${buttonColor} text-white px-3 py-2 rounded`}
            onClick={saveToAPI}
            disabled={isLoading}
          >
            Save
          </button>
          <button
            className="bg-red-500 text-white px-3 py-2 rounded hover:bg-red-600"
            onClick={handleClose}
            disabled={isLoading}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default KPIManagement;
